<template>
  <div class="general-info">
    <HeadLine>
     {{$ml.get('General Information')}}
    </HeadLine>
    <div class="th-fields-container">
      <div class="column">
        <ValueField :label="$ml.get('Name')" :value="section.data.name ? section.data.name : '-'"/>
        <ValueField :label="$ml.get('Farm')" :value="farm ? farm.name : '-'"/>
        <ValueField :label="$ml.get('pH')" :value="section.data.data.ph ? section.data.data.ph : '-'"/>
      </div>
      <div class="column">
        <ValueField :label="$ml.get('Date')" :value="section.data.date == 0 ? '-' : section.data.date"/>
        <ValueField :label="$ml.get('Field')" :value="field ? field.name : '-'"/>
        <ValueField :label="$ml.get('EC')" :value="section.data.data.ec ? section.data.data.ec.toFixed(2) + ' ' + $ml.get('dS/m') : '-'"/>
      </div>
    </div>
  </div>
</template>

<script>
import HeadLine from './../common/HeadLine';
import ValueField from './../common/ValueField';
export default {
  computed: {

    section() {
      return this.$root.data.waterTest;
      
    },

    field() {
      return this.$root.data.waterTest.data.field
    },

    farm() {
      return this.$root.data.waterTest.data.farm
    },
  },
  components: {
    HeadLine,
    ValueField,
  },
}
</script>

<style lang="scss" scoped>

.general-info {
  .head-line {
    margin-bottom: 10px;
  }

  .th-fields-container {
    margin-bottom: 20px;
  }
}

</style>